import React, { useState } from "react";
import { siteConfig } from "../../config/siteConfig";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const { faq } = siteConfig;

  return (
    <section id="faq" className="py-20 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-sm font-bold text-violet-600 uppercase tracking-wider">{faq.eyebrow}</span>
          <h2 className="text-4xl md:text-5xl font-black mt-4 mb-6 bg-gradient-to-r from-slate-900 to-slate-700 bg-clip-text text-transparent">
            {faq.title}
          </h2>
          <p className="text-xl text-slate-600">{faq.subtitle}</p>
        </div>

        <div className="space-y-4">
          {faq.items.map((item, index) => (
            <div key={index} className="bg-white rounded-2xl border border-slate-200 overflow-hidden hover:border-violet-200 transition-colors">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left"
              >
                <span className="font-bold text-slate-900 text-lg">{item.question}</span>
                <span className={`ml-4 flex-shrink-0 w-8 h-8 rounded-lg bg-slate-100 flex items-center justify-center transition-all ${openIndex === index ? "bg-violet-100 text-violet-600" : ""}`}>
                  <svg className={`w-5 h-5 transition-transform ${openIndex === index ? "rotate-180" : ""}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-5 animate-slideDown">
                  <div className="pt-2 border-t border-slate-100">
                    <p className="text-slate-600 leading-relaxed">{item.answer}</p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
